// Event Listener for document ready
document.addEventListener("DOMContentLoaded", function () {
    const authApiUrl = document.querySelector(".barkyn-api-url").value;
  
    const checkCreditYardCustomer = async () => {
      const email = document.querySelector(".barkyn-customer")?.value;
  
      if (!email) return;
  
      try {
        const response = await $.post(
          // `http://localhost:3003/check-prime-tag`,
          `${authApiUrl}/check-prime-tag`,
          JSON.stringify({ email })
        );
      } catch (error) {
        console.log(error);
      }
    };
  
    const checkCreditYardInput = () => {
      const input = document.querySelector(".credityard-panel__checkbox-input");
      const inputContainer = document.querySelector(
        ".credityard-panel-checkbox-container"
      );
  
      if (!input || !inputContainer) return;
  
      setTimeout(() => {
        const inputValue = window?.StoreCredit?.customRefundSubscriptionOrders;
  
        if (inputValue && inputValue === 1) {
          inputContainer.classList.add("checked");
        } else {
          inputContainer.classList.remove("checked");
        }
      }, 2000);
    };
  
    checkCreditYardInput();
  
    checkCreditYardCustomer();
  });
  